import React from 'react'
import { Box, Button, Card, CardContent, Container, Grid, InputAdornment, TextField, Tooltip, Typography } from '@mui/material'
import { collection, getDoc, getDocs, doc, updateDoc } from 'firebase/firestore'
import { useState } from 'react'
import ListaUsuarios from './ListaUsuarios'
import { db } from '../../firebase/firebase'
import { useEffect } from 'react'
import ModalSistema from '../../Components/Alertas/ModalSistema'
import SearchIcon from '@mui/icons-material/Search';
import SouthIcon from '@mui/icons-material/South';
import NorthIcon from '@mui/icons-material/North';

const Usuarios = () => {

    const [usuarios, setUsuarios] = useState([]);

    const [abrirModal, setAbrirModal] = useState(false);
    const handleClose = () => setAbrirModal(false);
    const [idUsuario, setIdUsuario] = useState('');
    const [value, setValue] = useState('');
    const [alfabetico, setAlfabetico] = useState(true);
    const [ordenRegistro, setOrdenRegistro] = useState(false);

    const obtenerUsuarios = async() =>{

        let arrayAux=[];

        const querySnapshot = await getDocs(collection(db, 'usuarios'));
        querySnapshot.docs.map((doc) =>{
            if(doc.data().rol === 'usuario'){
                if(doc.data().email.includes(value)){
                    arrayAux.push({id: doc.id, ...doc.data()})
                }
            }
        })
        
        arrayAux.sort((a, b) =>(a.email > b.email) ? 1 : ((b.email > a.email) ? -1 : 0))
        setUsuarios(arrayAux);
    }

    useEffect(() => {
        obtenerUsuarios();
    }, [value])

    const agregarAdministrador = async(id) =>{
        await updateDoc(doc(db, 'usuarios', idUsuario),{
            rol: 'admin'
        })
        setIdUsuario('');
        setAbrirModal(false);
        obtenerUsuarios();
    }

    const handleButton = (id) =>{
        setIdUsuario(id);
        setAbrirModal(true);
    }

    const handleChange = (e) =>{
        setValue(e.target.value)
        obtenerUsuarios();
    }

    const odenarAlfabetico = () =>{
        //Ordena de la A-Z
        if(alfabetico){
            usuarios.sort((a, b) =>(a.email > b.email) ? -1 : ((b.email > a.email) ? 1 : 0))
            setAlfabetico(false);
        }else{
            usuarios.sort((a, b) =>(a.email > b.email) ? 1 : ((b.email > a.email) ? -1 : 0))
            setAlfabetico(true)
        }
    }

    const ordenFecha = () =>{
        //Ordena de la A-Z
        if(!ordenRegistro){
            usuarios.sort((a, b) => new Date(...a.registro.split('/').reverse()) - new Date(...b.registro.split('/').reverse()));
            setOrdenRegistro(true);
        }else{
            usuarios.sort((a, b) => new Date(...b.registro.split('/').reverse()) - new Date(...a.registro.split('/').reverse()));
            setOrdenRegistro(false);
        }
    }

    return (
        <>
            <Box sx={{ marginLeft: "20%", borderBottom: "1px solid", width: "60%", marginTop: "3%" }}>
            <Grid container>
                <Grid item xs={10} md={10}>
                    <Typography component="div" gutterBottom style={{ color: "#000", fontSize: "40px" }}>
                        Usuarios
                    </Typography>
                </Grid>
            </Grid>
            </Box>
            
            <Box 
                sx={{ marginLeft: "20%", width: "60%", marginTop: "3%" }}
            >
                <Grid container spacing={1}>
                    <Grid item xs={6} md={8}>
                        <Box sx={{ maxWidth: 500 }}>
                            <TextField
                                fullWidth
                                onChange={handleChange}
                                InputProps={{
                                    startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon
                                            color="action"
                                            fontSize="small"
                                        >
                                        </SearchIcon>
                                    </InputAdornment>
                                    )
                                    
                                }}
                                placeholder="Buscar"
                                variant="outlined"
                            />
                        </Box>
                    </Grid>
                    <Grid item xs={10} md={2}>
                        {
                            alfabetico ?
                            (
                                <Tooltip title='Ordenar de la Z-A'>
                                    <Button
                                        onClick={odenarAlfabetico}
                                        endIcon={
                                            <NorthIcon
                                                fontSize='small'
                                            />
                                        }
                                    >
                                        Z-A
                                    </Button>
                                </Tooltip>
                            )
                            :
                            (
                                <Tooltip title='Ordenar de la A-Z'>
                                    <Button
                                        onClick={odenarAlfabetico}
                                        endIcon={
                                            <SouthIcon
                                                fontSize='small'
                                            />
                                        }
                                    >
                                        A-Z
                                    </Button>
                                </Tooltip>
                            )
                        }
                        
                    </Grid>
                    <Grid item xs={10} md={2}>
                        {
                            ordenRegistro ?
                            (
                                <Tooltip title='Ordenar de nuevo a antiguo'>
                                    <Button
                                        onClick={ordenFecha}
                                        endIcon={
                                            <SouthIcon
                                                fontSize='small'
                                            />
                                        }
                                    >
                                        Fecha
                                    </Button>
                                </Tooltip>
                            )
                            :
                            (
                                <Tooltip title='Ordenar de antiguo a nuevo'>
                                    <Button
                                        onClick={ordenFecha}
                                        endIcon={
                                            <NorthIcon
                                                fontSize='small'
                                            />
                                        }
                                    >
                                        Fecha
                                    </Button>
                                </Tooltip>
                            )
                        }
                    </Grid>
                </Grid>
            </Box>

            <Box sx={{ marginLeft: "10%", width: '80%', marginTop: '3%' }}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <ListaUsuarios 
                        usuarios={usuarios}
                        handleButton={handleButton}
                    />
                </Box>
            </Box>
            {
                abrirModal && (
                    <ModalSistema
                        abrirModal={abrirModal}
                        handleClose={handleClose}
                        funcion={agregarAdministrador}
                        titulo={'Agregar nuevo Administrador'}
                        mensaje={'¿Está seguro que desea dar permisos de administrador a este usuario?'}
                    />
                )
            }
            
        </>

    )
}

export default Usuarios